// extracted by mini-css-extract-plugin
export default {"logo":"CardLayout_logo__1zWGk","wrapper":"CardLayout_wrapper__nCKmK","link":"CardLayout_link__Fjtde"};